// Keep this list aligned with WallPreviewAdapter.offeredSKUs in parabo-swift.
const ELIGIBLE_PRODUCTS = new Set([
  'engineer-prints',
  'square-engineer-prints',
  'engineer-print-calendar',
  'news-print',
  'artprint',
  'metal-wall-prints',
  'framed-prints',
  'wrapped-canvas-prints',
  'acrylic-prints',
  'square-prints',
]);

export const isViewOnWallProduct = productId => ELIGIBLE_PRODUCTS.has(productId);

export const VIEW_ON_WALL_APP_STORE_URL = 'https://parabopress.onelink.me/19qg/6ciamodr';
